import styled from 'styled-components';

export const DescriptionStyles = styled.div`
  margin-top: 25px;
  max-width: 100%;

  @media (max-width: 1024px) {
    padding: 0px 22px;
  }

  @media (max-width: 512px) {
    padding: 0px 9px;
  }
`;

export const Header = styled.div`
  font-size: ${({ theme }) => theme.fontSize.lg};

  @media (max-width: 512px) {
    font-size: ${({ theme }) => theme.fontSize.xn};
  }
`;

export const Text = styled.div`
  margin-top: 16px;
  font-size: ${({ theme }) => theme.fontSize.nm};
  white-space: pre-line;
  word-break: break-word;

  @media (max-width: 512px) {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;
